// extracted by mini-css-extract-plugin
export var quantityInput = "_e4-0";